import React from 'react';
import { Input } from 'rsuite';

export const TextColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter },
}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={value => {
        setFilter(value || undefined); // Set undefined to remove the filter entirely
      }}
      size="xs"
    />
  );
};

export default TextColumnFilter;
